import { useLayerViewer } from "../map/layerViewer"
import { MapContext } from "../map/mapContext"
import { usePointsViewer } from "../map/pointsViewer"
import { useMapSelection } from "../map/selection"
import { useViewMapExtent } from "../map/viewExtent"
import { State } from "../state"

interface Props {
    state: State
    mapContext: MapContext
}

export function MapView({ state, mapContext }: Props) {

    const { selection, layerType, visibleLayers, selectedFieldKey, layerViewerOptions } = state
    const { groups, fields } = selection

    const map = mapContext?.map

    useLayerViewer(mapContext, layerType, visibleLayers, layerViewerOptions.opacity)

    usePointsViewer(selectedFieldKey, layerViewerOptions.points, mapContext, visibleLayers)

    useViewMapExtent(fields, map)

    useMapSelection(mapContext, groups, selectedFieldKey)

    if (!map) return null

    return <div className="map">

        <omnia.react.MapView map={map} />

    </div>


}
